<template>
  <div>
    <Header>
      <Heading1>{{ content.title }}</Heading1>
    </Header>
    <Content>

      <Paragraph v-for="(paragraph, i) in content.description" :key="i" v-html="paragraph"></Paragraph>
      <!-- <h3 class="margin-bottom-10">{{ content.thankMessage }}</h3>
      <Paragraph v-html="content.note"></Paragraph> -->
    </Content>
  </div>
</template>
<script>
import Header from '../components/base/Header.vue';
import Heading1 from '../components/base/Heading1.vue';
import Paragraph from '../components/base/Paragraph.vue';
import Content from '../components/base/Content.vue';

export default {
  name: "about",
  layout: "default",
  components: {
    Header,
    Heading1,
    Paragraph,
    Content
  },
  data: function () {
    return {
      content: {
        title: "About Us",
        description: [
          "Welcome to Macher Jobs, a premier online platform for job seekers and employers within the Jewish community in the United States. Macher Jobs specializes in connecting talented individuals with exceptional job opportunities. Our platform is designed to cater specifically to the needs of the Jewish community, providing a comprehensive range of services to streamline the job search process.",

          "At Macher Jobs, our primary focus is on helping individuals within the Jewish community find their ideal employment opportunities, while also assisting employers in recruiting top talent. With our user-friendly interface and advanced search technology, we ensure a seamless and efficient job search experience. Every job listing on our platform undergoes careful evaluation to ensure its authenticity and relevance, providing you with trusted and meaningful opportunities.",


          "We value your feedback and suggestions as we strive to be the leading online platform for job seekers and employers within the Jewish community. Your input helps us continually enhance our services and better serve your needs. We are dedicated to providing a reliable and secure platform that helps you achieve your career goals while staying connected to your community.",

          "Thank you for choosing Macher Jobs as your go-to platform. We appreciate your visit and look forward to assisting you in finding the perfect job or candidate. Together, let's build a thriving community within Macher Jobs that is rooted in success and opportunities."]
      }

    };
  },
  head() {
    const { path = "" } = this.$route;

    const metaTitle = this.content.title + " | Macher Jobs";
    const metaDescription = "Welcome to Macher Jobs, a premier online platform for job seekers and employers within the Jewish community in the United States."
    const canonical = process.env.baseUrl + path;

    return {
      title: metaTitle,
      link: [{ rel: "canonical", href: canonical }],
      meta: this.createMetaTags({
        description: metaDescription,
        title: metaTitle,
        canonical,
        socialTitle: metaTitle,
        socialDescription: metaDescription,
        siteName: "Macher Jobs",
        twitter: "@FrumJewishJobs",
      }),
    };
  },
};
</script>
<style scoped>
/* layer: default */
.description {
  margin-top: 1.875rem;
  margin-bottom: 1.875rem;
}

.content {
  padding: 1.5rem;
  max-width: 62rem;
  margin-left: auto;
  margin-right: auto;
}

.main-title {
  font-size: 3rem;
  line-height: 1;
  font-weight: 700;
}

.title5 {
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: 700;
}
</style>